module.exports = __webpack_public_path__ + "static/media/icon-marca.84e5d2d6.svg";